// extracted by mini-css-extract-plugin
module.exports = {"bridgeFont":"bridge_bridgeFont__EtQ1T","label":"bridge_label__smnaJ","responsiveLabel":"bridge_responsiveLabel__Gva_y"};